import { Component } from "react";

import { request } from "common/components/request";
import { Placeholder } from "common/components/placeholder";

export class RequestAccessButton extends Component {
    constructor() {
        super();
        this.state = {
            status: "idle"
        };
    }
    
    requestAccess = (e) => {
        e.preventDefault();
        
        this.setState({
            status: "loading"
        }, () => {
            request("/user/request_sso_user_activation", {
                method: "POST",
                ensureAuth: false,
                data: {
                    username: this.props.username
                }
            }).then((res) => {
                this.setState({
                    status: "success"
                });
            }).catch((error) => {
                this.setState({
                    status: "error"
                });
            });
        });
    };
    
    render() {
        if (!this.props.username) return null;
        
        if (this.state.status === "loading") {
            return <Placeholder size="short"/>;
        }
        
        if (this.state.status === "success") {
            return (
                <div style={{
                    display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", marginTop: 20
                }}
                >
                    <div style={{ fontSize: 18, marginBottom: 10 }}>Your request for access has been submitted</div>
                    <div>An email has been sent to the admins on this account. If your request for access is approved, they will let you know</div>
                </div>
            );
        }
        
        if (this.state.status === "error") {
            return (
                <div>
                    <div style={{ fontSize: 14, marginBottom: 10, color: "red" }}>There was error sending your request</div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <a onClick={this.requestAccess} href="#" className="pz-icon-text-button action-button">Try again</a>
                    </div>
                </div>
            );
        }
        
        return <a onClick={this.requestAccess} href="#" className="pz-icon-text-button action-button">Request access</a>;
    }
}
